/**
 * Single place that decides where a hit's swatches come from.
 *
 * Swatches are precomputed by bin/sync-algolia-swatches.js into the product
 * metafield custom.algolia_swatches, which the Algolia Shopify app syncs onto
 * every record as `meta.custom.algolia_swatches`. While the legacy connector
 * transformation still exists, its `swatches` field is used as a fallback so
 * the rollout can happen in either order without blank cards.
 */

function parseMaybeJson(value) {
  if (typeof value !== 'string') {
    return value;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

/**
 * @param {Object} hit - Algolia hit / Recommend item
 * @returns {Array} swatch entries (possibly empty); never null
 */
export function getHitSwatches(hit) {
  if (!hit) {
    return [];
  }

  const meta = hit.meta && hit.meta.custom ? hit.meta.custom.algolia_swatches : undefined;
  const fromMetafield = parseMaybeJson(meta);

  if (Array.isArray(fromMetafield)) {
    return fromMetafield;
  }

  return Array.isArray(hit.swatches) ? hit.swatches : [];
}
